import * as React from 'react';
import { List, Datagrid, TextField, DateField } from 'react-admin';
import { BulkActionButtons } from '../../common';
import { ListFilter } from './ListFilter';
import { rowColorStyle } from '../../../utils';

export default props => (
  <List
    {...props}
    filters={<ListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    bulkActionButtons={<BulkActionButtons resource='project' />}
    exporter={false}
  >
    <Datagrid rowClick='edit' rowStyle={rowColorStyle}>
      <TextField source='id' />
      <TextField source='name' />
      <TextField source='organisationName' />
      <TextField source='projectName' />
      <DateField source='createDate' />
      <DateField source='updateDate' />
    </Datagrid>
  </List>
);
